import { render, staticRenderFns } from "./certificate_train.vue?vue&type=template&id=18843694&scoped=true&"
import script from "./certificate_train.vue?vue&type=script&lang=js&"
export * from "./certificate_train.vue?vue&type=script&lang=js&"
import style0 from "./certificate_train.vue?vue&type=style&index=0&id=18843694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18843694",
  null
  
)

export default component.exports